import React, { useState } from "react";
import Layout from "../../layout/Layout";
import { Form } from "react-bootstrap";
import axiosInstance from "../../utils/axiosConfig";
import { useNavigate } from "react-router-dom";
import * as CustomToast from "../../components/CustomToastMessage";
import BlogImageUpload from "../../components/blogImageUpload";

function CategoryAdd() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    categoryImage: null,
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleImageUpload = (file) => {
    setFormData((prev) => ({ ...prev, categoryImage: file }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.categoryImage) {
      CustomToast.error("Please select a category image");
      return;
    }
    const formDataToSend = new FormData();
    formDataToSend.append("name", formData.name);
    formDataToSend.append("categoryImage", formData.categoryImage);
    formDataToSend.append("priority", formData?.priority || null);
    setLoading(true);
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/category/create`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      CustomToast.success(response.data.message);
      navigate("/category");
    } catch (error) {
      if (error.response?.data?.status === 400) {
        CustomToast.error(error.response?.data?.message);
      }
      console.error(error.response?.data?.message || "Error sending response");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout title="Add Category">
      <main>
        <div className="card page-card">
          <div className="card-body">
            <div className="row g-3">
              <div className="col-12">
                <Form.Group controlId="categoryImage">
                  <Form.Label>Category Image</Form.Label>
                  <BlogImageUpload onFileSelect={handleImageUpload} />
                </Form.Group>
              </div>
              <div className="col-6">
                <Form.Group controlId="name">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Enter category name"
                  />
                </Form.Group>
              </div>
              <div className="col-6">
                <Form.Group controlId="priority">
                  <Form.Label>Priority</Form.Label>
                  <Form.Control
                    type="number"
                    name="priority"
                    placeholder="Priority"
                    min="1"
                    step="1"
                    value={formData?.priority || ""}
                    onChange={handleInputChange}
                    onKeyDown={(e) => {
                      const { value } = e.target;

                      const invalidKeys = [
                        "e",
                        "E",
                        "+",
                        "-",
                        ".",
                        "ArrowDown",
                        "ArrowUp",
                      ];
                      if (
                        invalidKeys.includes(e.key) ||
                        (e.key === "0" && !value)
                      ) {
                        e.preventDefault();
                        return;
                      }
                    }}
                    onPaste={(e) => {
                      if (isNaN(e.clipboardData.getData("text"))) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Group>
              </div>
              <div className="col-12 d-flex justify-content-end gap-3">
                <button
                  className="btn-outline fs-16 fw-700 px-4"
                  onClick={() => navigate("/category")}
                  type="button"
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  className="btn-primary fs-16 fw-700 px-4"
                  onClick={handleSubmit}
                  type="button"
                  disabled={loading}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
}

export default CategoryAdd;
